var _defs, _rect, _rect2, _text, _text2, _rect3, _text3, _text4, _rect4, _text5, _text6, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramMemory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 360,
    viewBox: "0 0 520 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "memg",
    x1: 0,
    y1: 0,
    x2: 520,
    y2: 360
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#22D3EE",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#34D399",
    stopOpacity: 0.9
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 488,
    height: 328,
    rx: 22,
    fill: "#0B0F18",
    stroke: "#1F2937"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 50,
    width: 400,
    height: 70,
    rx: 18,
    fill: "#111827",
    stroke: "url(#memg)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 86,
    fill: "#E2E8F0",
    fontSize: 16,
    fontFamily: "DM Sans, Arial"
  }, "STM")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 106,
    fill: "#94A3B8",
    fontSize: 12,
    fontFamily: "DM Sans, Arial"
  }, "verbatim recent messages")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 145,
    width: 400,
    height: 80,
    rx: 18,
    fill: "#111827",
    stroke: "url(#memg)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 182,
    fill: "#E2E8F0",
    fontSize: 16,
    fontFamily: "DM Sans, Arial"
  }, "CWM")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 204,
    fill: "#94A3B8",
    fontSize: 12,
    fontFamily: "DM Sans, Arial"
  }, "structured memory with decisions, constraints")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 250,
    width: 400,
    height: 70,
    rx: 18,
    fill: "#111827",
    stroke: "url(#memg)"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 286,
    fill: "#E2E8F0",
    fontSize: 16,
    fontFamily: "DM Sans, Arial"
  }, "LTM")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 306,
    fill: "#94A3B8",
    fontSize: 12,
    fontFamily: "DM Sans, Arial"
  }, "stable knowledge retrieved on demand")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260 120 L260 145",
    stroke: "#38BDF8",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M260 225 L260 250",
    stroke: "#38BDF8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramMemory);
export default __webpack_public_path__ + "static/media/diagram-memory.70eee766ae4ac4d78e56751c18111049.svg";
export { ForwardRef as ReactComponent };